<template>
    <v-form @submit.prevent="addEditTeamRole" ref="form">
        <v-card dense style="border-radius:4px;">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">{{mode}} Team Role</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>  
                <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                    {{errorMessage}}
                </v-alert>    
                <v-layout row wrap class="form-container">  
                    <v-flex xs12 sm12>
                        <v-text-field label="Name" 
                            v-model="name" 
                            :rules="[rules.required, rules.unique_name]" 
                            :disabled="disabled"
                            hint="Max 50 characters"
                            max="50"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12>
                            <v-textarea label="Description"
                                v-model="description"
                                :rules="[rules.required]"
                                maxlength="1000"
                                rows="1"
                                hint="Max 1000 characters"
                                :disabled="disabled"></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm12 style="margin-top:-10px;">
                        <v-switch
                            v-model="visibleInMyTeams"
                            label="Show in My Teams"
                            color="primary"
                            persistent-hint
                            :hint="visibleInMyTeams?'This role will appear on the My Teams page as a separate section with its team members listed below.':'This role will not appear on the My Teams page.'"
                        ></v-switch> 
                    </v-flex>
                </v-layout>
            </v-card-text>  
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="mode!='Edit'" @click="clearForm" :disabled="disabled">Clear</v-btn>
                <v-btn color="primary" type="submit" :loading="loading" dark style="margin-right:25px;">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>
import teamRolesApi from '@/api/teamroles'
export default {
    name: 'addEditTeamRole',
    components: {},   
    data () {
        return {
            error: false,
            errorMessage: '', 
            loading: false,
            disabled: false,
            error: false,       
            rules: {
                required: value => !!value || 'Required.',
                unique_name: value => {
                    if (!value) return true
                    const exists = this.current_team_roles.some(
                        x => x.name.toLowerCase() === value.toLowerCase()
                    )
                    return !exists || 'Name already exists'
                }
            },
            mode: '',
            teamRoleId: null,
            name: null,
            description: null,
            visibleInMyTeams: 0,
            current_team_roles: []
        }
    },
    methods: {
        closeDialog() {
            this.$emit('update:dialogAddEdit', false)
            this.clearForm()
        },
        setAdd(data) {            
            this.mode = 'Add'
            this.current_team_roles = data
            this.teamRoleId = null
            this.name = null
            this.description = null
            this.visibleInMyTeams = 0
        },
        setEdit(data) {
            this.mode = 'Edit'
            if (!this.current_team_roles) {
                this.getRoles()
            }
            this.teamRoleId = data.teamRoleId
            this.name = data.name
            this.description = data.description
            this.visibleInMyTeams = data.visibleInMyTeams
        },
        async addEditTeamRole() {         
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true
                    var data = {
                        teamRoleId: this.teamRoleId,
                        name: this.name,
                        description: this.description,
                        visibleInMyTeams: this.visibleInMyTeams
                    }
                    const response = await teamRolesApi.upsertRole(data)
                    if (response && response.status == 200) {
                        this.loading = false
                        this.disabled = false                    
                        this.closeDialog()
                        this.$emit('send', response.data)
                    }
                }catch(error){
                    this.errorMessage = error
                    this.error = true
                }        
            }
        }, 
        async getRoles() {
            try {
                const response = await teamRolesApi.getRoles() 
                if (response && response.status == 200) {
                    this.current_team_roles = response.data.items
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },       
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        }
    },
    computed: {},
    created() {}
}
</script>
<style scoped>
.form-container {
    padding:0px 25px 0px 25px;
}
</style>